import { useRestaurants, restaurantDesc, diningCardRestaurants } from '../lib/useRestaurants';

const CATEGORIES = [
  ['steakhouse', 'steakhouseTitle'],
  ['seafood', 'seafoodTitle'],
  ['italian', 'italianTitle'],
  ['fine', 'fineDiningTitle'],
];

const ALCOHOL_LABEL = {
  en: { served: 'Alcohol served', not_served: 'Alcohol-free', unknown: 'Alcohol status unknown' },
  ar: { served: 'تُقدَّم المشروبات الكحولية', not_served: 'خالٍ من الكحول', unknown: 'حالة الكحول غير معروفة' },
  ru: { served: 'Алкоголь подаётся', not_served: 'Без алкоголя', unknown: 'Статус алкоголя неизвестен' },
  tr: { served: 'Alkol servisi var', not_served: 'Alkolsüz', unknown: 'Alkol durumu bilinmiyor' },
};

export function alcoholLabel(status, language) {
  return (ALCOHOL_LABEL[language] || ALCOHOL_LABEL.en)[status] || ALCOHOL_LABEL.en.unknown;
}

export function DiningCards({ t, language, testIdPrefix, sectionTestId, sectionId }) {
  const { restaurants } = useRestaurants();
  const cards = diningCardRestaurants(restaurants);
  if (!cards.length) return null;
  return (
    <div className="business-dining-section" id={sectionId} data-testid={sectionTestId}>
      <p className="business-dining-tip">{t.tours.businessDining.tip}</p>
      <h3 className="business-dining-title" data-testid={`${testIdPrefix}-title`}>{t.tours.businessDining.title}</h3>
      {CATEGORIES.map(([cat, titleKey]) => {
        const rows = cards.filter(r => r.card_category === cat);
        if (!rows.length) return null;
        return (
          <div className="dining-category" key={cat}>
            <h4 className="dining-category-title">{t.tours.businessDining[titleKey]}</h4>
            <div className={`dining-grid ${rows.length >= 3 ? 'dining-grid-3' : ''}`}>
              {rows.map(r => (
                <div className="dining-card" key={r.id} data-testid={`${testIdPrefix}-${r.id}`}>
                  <h5 className="dining-name">{r.name}{r.partner && <span className="dining-partner-badge" data-testid={`${testIdPrefix}-${r.id}-partner`}>{language === 'ar' ? 'مطعم شريك' : 'Partner restaurant'}</span>}</h5>
                  <p className="dining-specialty">{t.tours.businessDining.specialty}: {restaurantDesc(r, language)}</p>
                  <p className="dining-location" dir="ltr" style={{ textAlign: 'start' }}>{r.address || r.area}</p>
                  <p className="dining-alcohol" data-testid={`${testIdPrefix}-${r.id}-alcohol`}>{alcoholLabel(r.alcohol, language)}</p>
                  <div className="dining-contact">
                    {r.website && <a href={r.website} target="_blank" rel="noopener noreferrer">{r.website.replace(/^https?:\/\/(www\.)?/, '').replace(/\/.*$/, '')}</a>}
                    {r.phone && <a href={`tel:${r.phone.replace(/\s+/g, '')}`} dir="ltr">{r.phone}</a>}
                  </div>
                </div>
              ))}
            </div>
          </div>
        );
      })}
    </div>
  );
}
